export const isHurricaneAffected = (zip: string, hurricaneDate: string = '12/24/2024') => {
  const today = new Date();
  if (today > new Date(hurricaneDate)) {
    return false;
  }
  return HURRICANE_ZIPCODES.includes(zip);
};

export const HURRICANE_ZIPCODES: string[] = [
  // CONNECTICUT
  '06010',
  '06011',
  '06237',
  '06247',
  '06255',
  '06260',
  '06277',
  '06412',
  '06443',
  '06444',
  '06468',
  '06477',
  '06491',
  '06501',
  '06502',
  '06503',
  '06504',
  '06505',
  '06506',
  '06507',
  '06508',
  '06509',
  '06510',
  '06511',
  '06512',
  '06513',
  '06513',
  '06515',
  '06517',
  '06519',
  '06520',
  '06521',
  '06524',
  '06525',
  '06530',
  '06531',
  '06532',
  '06533',
  '06534',
  '06535',
  '06536',
  '06611',
  '06612',
  '06759',
  '06793',
  '06824',
  '06825',
  // VIRGINIA
  '20159',
  '20160',
  '22009',
  '22015',
  '22151',
  '22709',
  '22711',
  '22715',
  '22719',
  '22725',
  '22727',
  '22730',
  '22731',
  '22732',
  '22738',
  '22740',
  '22743',
  '22747',
  '22943',
  '22948',
  '22957',
  '22960',
  '23038',
  '23069',
  '23075',
  '23084',
  '23149',
  '23185',
  '23187',
  '23188',
  '23218',
  '23219',
  '23220',
  '23221',
  '23222',
  '23223',
  '23224',
  '23225',
  '23226',
  '23227',
  '23230',
  '23231',
  '23241',
  '23250',
  '23260',
  '23261',
  '23285',
  '23605',
  '23651',
  '23661',
  '23662',
  '23663',
  '23664',
  '23665',
  '23666',
  '23669',
  '23670',
  '23831',
  '23836',
  '23851',
  '24066',
  '24070',
  '24102',
  '24141',
  '24143',
  '24201',
  '24202',
  '24203',
  '24209',
  '24225',
  '24273',
  '24293',
  '24301',
  '24311',
  '24314',
  '24315',
  '24324',
  '24333',
  '24354',
  '24381',
  '24435',
  '24440',
  '24450',
  '24472',
  '24476',
  '24483',
  '24501',
  '24502',
  '24503',
  '24504',
  '24505',
  '24506',
  '24523',
  '24531',
  '24540',
  '24541',
  '24543',
  '24565',
  '24574',
  '24608',
  '24651',
  '37620',
  '37621',
  '37625',
  // NORTH CAROLINA
  '27013',
  '27025',
  '27256',
  '27278',
  '27283',
  '27292',
  '27293',
  '27295',
  '27298',
  '27355',
  '27536',
  '27537',
  '27551',
  '27586',
  '27594',
  '27826',
  '27832',
  '27833',
  '27834',
  '27835',
  '27836',
  '27840',
  '27845',
  '27853',
  '27858',
  '27866',
  '27876',
  '27889',
  '27921',
  '27925',
  '27973',
  '27974',
  '28079',
  '28110',
  '28111',
  '28112',
  '28201',
  '28202',
  '28203',
  '28204',
  '28205',
  '28206',
  '28207',
  '28208',
  '28209',
  '28210',
  '28211',
  '28212',
  '28213',
  '28214',
  '28215',
  '28216',
  '28217',
  '28218',
  '28219',
  '28220',
  '28221',
  '28222',
  '28224',
  '28226',
  '28229',
  '28230',
  '28231',
  '28232',
  '28233',
  '28234',
  '28235',
  '28236',
  '28237',
  '28241',
  '28247',
  '28256',
  '28262',
  '28266',
  '28269',
  '28271',
  '28272',
  '28273',
  '28277',
  '28278',
  '28297',
  '28299',
  '28421',
  '28516',
  '28609',
  '28613',
  '28615',
  '28640',
  '28658',
  '28701',
  '28712',
  '28715',
  '28719',
  '28734',
  '28737',
  '28741',
  '28744',
  '28752',
  '28768',
  '28773',
  '28775',
  '28790',
  // SOUTH CAROLINA
  '29003',
  '29020',
  '29021',
  '29037',
  '29038',
  '29039',
  '29051',
  '29052',
  '29053',
  '29058',
  '29061',
  '29067',
  '29071',
  '29072',
  '29073',
  '29080',
  '29104',
  '29108',
  '29115',
  '29116',
  '29118',
  '29133',
  '29138',
  '29145',
  '29150',
  '29151',
  '29153',
  '29154',
  '29175',
  '29201',
  '29202',
  '29203',
  '29204',
  '29205',
  '29206',
  '29207',
  '29209',
  '29210',
  '29211',
  '29212',
  '29221',
  '29223',
  '29224',
  '29229',
  '29230',
  '29240',
  '29250',
  '29260',
  '29290',
  '29301',
  '29302',
  '29303',
  '29304',
  '29305',
  '29306',
  '29307',
  '29316',
  '29360',
  '29379',
  '29541',
  '29571',
  '29601',
  '29602',
  '29603',
  '29604',
  '29605',
  '29606',
  '29607',
  '29608',
  '29609',
  '29610',
  '29611',
  '29615',
  '29616',
  '29617',
  '29620',
  '29621',
  '29622',
  '29623',
  '29624',
  '29625',
  '29626',
  '29635',
  '29646',
  '29648',
  '29649',
  '29657',
  '29667',
  '29671',
  '29675',
  '29685',
  '29704',
  '29706',
  '29717',
  '29718',
  '29726',
  '29743',
  '29745',
  '29801',
  '29802',
  '29803',
  '29804',
  '29805',
  '29810',
  '29812',
  '29813',
  '29824',
  '29831',
  '29836',
  '29901',
  '29902',
  '29903',
  '29904',
  '29906',
  '29907',
  '29911',
  '29924',
  // GEORGIA
  '30017',
  '30113',
  '30143',
  '30148',
  '30175',
  '30177',
  '30205',
  '30216',
  '30217',
  '30222',
  '30228',
  '30233',
  '30451',
  '30528',
  '30545',
  '30549',
  '30557',
  '30571',
  '30625',
  '30641',
  '30648',
  '30650',
  '30655',
  '30656',
  '30660',
  '30668',
  '30673',
  '30701',
  '30703',
  '30802',
  '30809',
  '30820',
  '31001',
  '31012',
  '31067',
  '31201',
  '31202',
  '31203',
  '31204',
  '31205',
  '31206',
  '31208',
  '31209',
  '31210',
  '31211',
  '31216',
  '31217',
  '31220',
  '31221',
  '31518',
  '31560',
  '31629',
  '31811',
  '31823',
  '31824',
  '31825',
  '31832',
  '39837',
  '39870',
  // FLORIDA
  '32044',
  '32052',
  '32059',
  '32111',
  '32321',
  '32331',
  '32340',
  '32341',
  '32350',
  '32423',
  '32443',
  '32531',
  '32564',
  '32615',
  '32616',
  '32634',
  '32669',
  '32692',
  '33480',
  '33480',
  '33772',
  '33774',
  '33775',
  '33776',
  '33777',
  '34230',
  '34231',
  '34232',
  '34233',
  '34234',
  '34235',
  '34236',
  '34237',
  '34238',
  '34239',
  '34240',
  '34241',
  '34242',
  '34243',
  '34276',
  '34277',
  '34441',
  '34972',
  '34973',
  '34974',
  // TENNESSEE
  '37036',
  '37064',
  '37065',
  '37067',
  '37068',
  '37069',
  '37083',
  '37095',
  '37115',
  '37116',
  '37189',
  '37309',
  '37311',
  '37312',
  '37320',
  '37323',
  '37347',
  '37352',
  '37364',
  '37658',
  '37692',
  '37694',
  '37879',
  '38222',
  '38231',
  '38237',
  '38301',
  '38302',
  '38303',
  '38305',
  '38308',
  '38314',
  '38316',
  '38320',
  '38337',
  '38340',
  '38351',
  '38369',
  '38401',
  '38402',
  '38478',
  '38541',
  '38570',
  '38573',
  '38589',
  // ILLINOIS
  '60071',
  '60075',
  '60180',
  '60184',
  '60463',
  '60464',
  '60465',
  '60482',
  '60512',
  '60530',
  '60538',
  '61087',
  '61088',
  '61235',
  '61252',
  '61256',
  '61421',
  '61439',
  '61537',
  '61560',
  '61571',
  '61753',
  '61811',
  '61814',
  '61817',
  '61832',
  '61833',
  '61834',
  '61858',
  '61883',
  '62056',
  '62058',
  '62060',
  '62233',
  '62236',
  '62239',
  '62246',
  '62284',
  '62319',
  '62338',
  '62341',
  '62347',
  '62365',
  '62401',
  '62410',
  '62419',
  '62448',
  '62479',
  '62510',
  '62544',
  '62553',
  '62555',
  '62601',
  '62629',
  '62638',
  '62656',
  '62809',
  '62837',
  '62867',
  '62886',
  '62909',
  '62912',
  '62959',
  '62976',
  // LOUISIANA
  '70501',
  '70502',
  '70503',
  '70505',
  '70506',
  '70507',
  '70508',
  '70509',
  '70510',
  '70511',
  '70538',
  '70540',
  '70583',
  '70589',
  '70596',
  '70598',
  '70639',
  '70704',
  '70714',
  '70730',
  '70736',
  '70748',
  '70754',
  '71007',
  '71033',
  '71080',
  '71201',
  '71202',
  '71203',
  '71207',
  '71210',
  '71211',
  '71213',
  '71225',
  '71226',
  '71260',
  '71286',
  '71418',
  '71435',
  '71454',
];